import { render, staticRenderFns } from "./AccountProfileSettings.vue?vue&type=template&id=8f2f4f34&"
import script from "./AccountProfileSettings.vue?vue&type=script&lang=js&"
export * from "./AccountProfileSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports